export default __webpack_public_path__ + "static/media/bs_img2.8db93209.jpg";